// extracted by mini-css-extract-plugin
module.exports = {"top":"SlideDown_top__8KovQ","accordion_header":"SlideDown_accordion_header__LH5XM"};